import { Group, Kbd, Text } from '@mantine/core';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

type NavigatorWithUserAgentData = Navigator & { userAgentData?: { platform: string } };

export const IS_APPLE = /mac|iphone|ipad/i.test(
    (navigator as NavigatorWithUserAgentData).userAgentData?.platform ?? navigator.userAgent
);
export const MOD_KEY = IS_APPLE ? '⌘' : 'Ctrl';

type ShortcutHintProps = {
    label: string;
    keys: string[][];
};

export function ShortcutHint({ label, keys }: Readonly<ShortcutHintProps>) {
    const { t } = useTranslation();
    return (
        <Group gap="var(--spacing-3)" wrap="nowrap">
            <span>{label}</span>
            <Group gap="var(--spacing-2)" wrap="nowrap">
                {keys.map((combo, comboIndex) => (
                    <Fragment key={combo.join('+')}>
                        {comboIndex > 0 && (
                            <Text c="dimmed" component="span" size="xs">
                                {t('shortcut.or')}
                            </Text>
                        )}
                        <Group gap="var(--spacing-1)" wrap="nowrap">
                            {combo.map((key, keyIndex) => (
                                <Fragment key={key}>
                                    {keyIndex > 0 && (
                                        <Text c="dimmed" component="span" size="xs">
                                            +
                                        </Text>
                                    )}
                                    <Kbd size="xs" style={{ color: 'var(--color-foreground-panel)' }}>
                                        {key}
                                    </Kbd>
                                </Fragment>
                            ))}
                        </Group>
                    </Fragment>
                ))}
            </Group>
        </Group>
    );
}
